module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "map-area section-padding hezuo_section1",
    staticStyle: {
      "height": "800px"
    }
  }, [_c('div', {
    staticClass: "banner-sun"
  }, [_c('p', {
    staticClass: "p1 animate fadeInDown animated jjfangan_zt1",
    staticStyle: {
      "animation-duration": "1s",
      "animation-delay": "0.1s",
      "visibility": "visible"
    }
  }, [_vm._v("合作伙伴")]), _vm._v(" "), _c('p', {
    staticClass: "p2 animate zoomIn animated jjfangan_zt2",
    staticStyle: {
      "animation-duration": "1s",
      "animation-delay": "1s",
      "visibility": "visible",
      "color": "#E91E63"
    }
  }, [_vm._v(_vm._s(_vm.hbname))])])]), _vm._v(" "), _c('section', {
    staticClass: "section-padding8"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "donghuasun hezuokuandu",
    staticStyle: {
      "width": "100%",
      "height": "200px",
      "border-bottom": "1px solid #ccc",
      "text-align": "center",
      "animation-duration": "1s",
      "animation-delay": "0.3s"
    }
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "20px",
      "font-weight": "600",
      "color": "#666666"
    }
  }, [_vm._v("战略合作伙伴 · "), _c('span', {
    staticStyle: {
      "color": "#44BCB9"
    }
  }, [_vm._v(_vm._s(_vm.newsinfo.title))])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("• " + _vm._s(_vm.newsinfo.date))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("浏览量：" + _vm._s(_vm.newsinfo.visits))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "auto",
      "margin-top": "40px",
      "line-height": "40px",
      "display": "flex"
    }
  }, [_c('p', {
    staticStyle: {
      "width": "100%"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.newsinfo.content)
    }
  }), _vm._v(" "), _vm._m(1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('br'), _c('br'), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('br')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04773cad"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/huoban.vue
// module id = 99
// module chunks = 0